<div class="page-title animatedBackground">
    <div class="container">
        <h3>Privacy Policy</h3>
        <ul>
            <li><a routerLink="/">Home</a></li>
            <li class="dot-divider"></li>
            <li>Privacy Policy</li>
        </ul>
    </div>
    <div class="bg-pattern"><img src="assets/img/bg-pattern-2.png" alt="pattern"></div>
</div>

<section class="blog-details-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="blog-details">
                    <div class="blog-details-heading">
                        <h3>Privacy Policy</h3>
                        <ul>
                            <li>Effective Date: <a href="#">June/2025</a></li>
                        </ul>
                    </div>
                    <div class="blog-details-content">
                        <p>
                            Welcome to AM Media and Sports Pvt Ltd. Your privacy is important to us, and we are
                            committed to protecting the personal information you share with us. This Privacy Policy
                            explains how we collect, use, disclose, and safeguard your information when you visit our
                            website, enrol in our programs, and interact with our services.
                        </p>
                        <div class="project-details">
                            <div class="row">
                                <div class="col-lg-12 col-md-12">
                                    <h3>Information We Collect</h3>
                                    <p>We collect different types of information to provide and improve our services,
                                        including:</p>
                                </div>
                            </div>
                            <div class="pt-5 row">
                                <div class="col-lg-12 col-md-12">
                                    <h3>Personal Information</h3>
                                    <p>When you register on our platform, apply for a course, or contact us, we may
                                        collect:</p>
                                    <ul class="features">
                                        <li>Full Name</li>
                                        <li>Email Address</li>
                                        <li>Phone Number</li>
                                        <li>Date of Birth</li>
                                        <li>Educational Background</li>
                                        <li>Work Experience (if applicable)</li>
                                        <li>Payment Information (when applicable)</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="pt-5 row">
                                <div class="col-lg-12 col-md-12">
                                    <h3>Non-Personal Information</h3>
                                    <p>We may also collect non-personally identifiable information such as:</p>
                                    <ul class="features">
                                        <li>Browser type and version</li>
                                        <li>Device type (mobile, tablet, desktop)</li>
                                        <li>IP Address</li>
                                        <li>Operating system</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="pt-5 row">
                                <div class="col-lg-12 col-md-12">
                                    <h3>Cookies and Tracking Technologies</h3>
                                    <p>We use cookies, web beacons, and other tracking technologies to enhance user
                                        experience, analyze trends, and track website activity.</p>
                                </div>
                            </div>
                            <div class="pt-5 row">
                                <div class="col-lg-12 col-md-12">
                                    <h3>How We Use Your Information</h3>
                                    <p>We use the collected data to:</p>
                                    <ul class="features">
                                        <li>Provide and personalize our courses and services</li>
                                        <li>Process payments and enrollments</li>
                                        <li>Send course updates, notifications, and promotional emails</li>
                                        <li>Improve website functionality and user experience</li>
                                        <li>Conduct analytics to enhance learning outcomes</li>
                                        <li>Ensure compliance with legal and regulatory requirements</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="pt-5 row">
                                <div class="col-lg-12 col-md-12">
                                    <h3>Sharing and Disclosure of Information</h3>
                                    <p>We do not sell, rent, or trade your personal data. However, we may share
                                        information with:</p>
                                    <ul class="features">
                                        <li>Service Providers – Third-party vendors who assist in payment processing,
                                            analytics, and course delivery.</li>
                                        <li>Business Partners – If you enroll in partner programs, your information may
                                            be shared with affiliated institutions.</li>
                                        <li>Legal & Compliance – If required by law, regulation, or legal process, we
                                            may disclose your information.</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="pt-5 row">
                                <div class="col-lg-12 col-md-12">
                                    <h3>Data Security</h3>
                                    <p>We take the security of your personal data seriously and implement:</p>
                                    <ul class="features">
                                        <li>SSL encryption for data transmission</li>
                                        <li>Secure payment processing via trusted third-party gateways</li>
                                        <li>Access controls and authentication mechanisms</li>
                                        <li>Regular security audits and compliance checks However, no internet
                                            transmission is 100% secure, and we encourage users to take precautions when
                                            sharing personal information online.</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="pt-5 row">
                                <div class="col-lg-12 col-md-12">
                                    <h3>Your Rights and Choices</h3>
                                    <p>As a user of AM Media and Sports Pvt Ltd, you have the right to:</p>
                                    <ul class="features">
                                        <li>Access & Review – Request a copy of the data we hold about you.</li>
                                        <li>Correction – Update or correct any inaccurate personal information.</li>
                                        <li>Opt-Out – Unsubscribe from marketing emails at any time.</li>
                                        <li>Delete Data – Request the removal of your data under applicable laws.</li>
                                        <li>To exercise these rights, please contact us at [insert contact email].</li>
                                    </ul>
                                </div>
                            </div>
                            <div class="pt-5 row">
                                <div class="col-lg-12 col-md-12">
                                    <h3>Third-Party Links</h3>
                                    <p>Our website may contain links to third-party websites, such as job portals,
                                        educational platforms, or corporate partners. We are not responsible for the
                                        privacy policies or content of these external sites.</p>
                                </div>
                            </div>
                            <div class="pt-4 row">
                                <div class="col-lg-12 col-md-12">
                                    <h3>Data Retention</h3>
                                    <p>We retain your personal data for as long as necessary to fulfill the purposes
                                        outlined in this Privacy Policy or as required by law.</p>
                                </div>
                            </div>
                            <div class="pt-4 row">
                                <div class="col-lg-12 col-md-12">
                                    <h3>Updates to This Privacy Policy</h3>
                                    <p>We may update this policy from time to time. Any changes will be reflected on
                                        this page with an updated "Last Updated" date.</p>
                                </div>
                            </div>
                            <div class="pt-4 row">
                                <div class="col-lg-12 col-md-12">
                                    <h3>Contact Us</h3>
                                    <p>If you have any questions about this Privacy Policy or our data practices, please
                                        contact us at: 📧 Email: <a
                                            href="email:info@ammediasports.com">ammediasports.com</a> Thank you for
                                        trusting us with
                                        your learning journey. Your privacy matters to us. 🚀</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>